import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {FormGroup} from '@blueprintjs/core';

import SelectAttachments from './Select';
import {blocksToOptions, getSourceBlocks} from './utils';

interface AttachmentsProps {
  value: string[];
  onChange?: (attachments: string[]) => void;
  disabled?: boolean;
  inline?: boolean;
  className?: string;
}

export const Attachments = ({
  value,
  onChange,
  disabled = false,
  inline = false,
  className,
}: AttachmentsProps) => {
  const allBlocks = useSelector((state: any) => state.block.blocks);
  const sourceBlocks = getSourceBlocks(allBlocks);
  const options = useMemo(() => blocksToOptions(sourceBlocks), [sourceBlocks?.length]);

  const _onChange = (value: string[]) => {
    if (disabled) {
      return;
    }
    onChange && onChange(value);
  };

  return (
    <FormGroup label="Attachments" inline={inline} className={className}>
      <SelectAttachments
        value={value}
        options={options}
        disabled={disabled || (!options.length && !value?.length)}
        onChange={_onChange}
      />
    </FormGroup>
  );
}

export default Attachments;
